import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, Card, Loading, Avatar } from "../components/ui";

const PLABEL = { 1: "Low", 2: "Medium", 3: "High" };
// box color by combined score
function boxTone(perf, pot) {
  const s = perf + pot;
  if (s >= 5) return "bg-emerald-50 dark:bg-emerald-500/10 border-emerald-300/60 dark:border-emerald-500/30";
  if (s <= 3) return "bg-red-50 dark:bg-red-500/10 border-red-300/60 dark:border-red-500/30";
  return "bg-amber-50 dark:bg-amber-500/10 border-amber-300/60 dark:border-amber-500/30";
}

export default function Talent() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/talent").then(({ data }) => setData(data)); }, []);
  if (!data) return <Loading />;
  const cell = (perf, pot) => data.grid.filter((g) => g.performance === perf && g.potential === pot);

  return (
    <div>
      <PageHeader title="Talent Hub" subtitle="9-box performance vs. potential grid" />
      <Card className="p-6">
        <div className="flex gap-3">
          <div className="flex w-6 items-center justify-center">
            <span className="-rotate-90 whitespace-nowrap text-xs font-semibold uppercase tracking-widest text-slate-400">Potential →</span>
          </div>
          <div className="flex-1 overflow-x-auto">
            <div className="grid min-w-[460px] grid-cols-3 gap-3">
              {[3, 2, 1].map((pot) => (
                [1, 2, 3].map((perf) => {
                  const people = cell(perf, pot);
                  return (
                    <div key={`${perf}-${pot}`} data-testid={`box-${perf}-${pot}`} className={`min-h-[130px] rounded-lg border p-3 ${boxTone(perf, pot)}`}>
                      <p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-slate-400">{PLABEL[pot]} pot · {PLABEL[perf]} perf</p>
                      <div className="flex flex-wrap gap-1.5">
                        {people.map((p) => (
                          <div key={p.id} title={`${p.name} (${p.department})`} className="flex items-center gap-1.5 rounded-full bg-white px-2 py-1 shadow-sm dark:bg-slate-800">
                            <Avatar name={p.name} size={20} /><span className="text-xs font-medium text-slate-700 dark:text-slate-200">{p.name.split(" ")[0]}</span>
                          </div>
                        ))}
                        {people.length === 0 && <span className="text-xs text-slate-300 dark:text-slate-600">—</span>}
                      </div>
                    </div>
                  );
                })
              ))}
            </div>
            <div className="mt-3 text-center text-xs font-semibold uppercase tracking-widest text-slate-400">Performance →</div>
          </div>
        </div>
      </Card>
      <p className="mt-4 text-sm text-slate-400">Placement derived from latest review rating (performance) and goal progress (potential) across {data.total} employees.</p>
    </div>
  );
}
